@if (!loaded()) {
  <span class="media-image__loader" aria-hidden="true">
    <span class="media-image__spin"></span>
  </span>
}
@if (displaySrc()) {
  @if (kind() === 'video') {
    <video
      [src]="displaySrc()"
      [poster]="poster() || null"
      controls
      playsinline
      (loadeddata)="onReady()"
      (error)="onError()"
    ></video>
  } @else {
    <img
      [src]="displaySrc()"
      [alt]="alt()"
      [attr.loading]="loading()"
      (load)="onReady()"
      (error)="onError()"
    />
  }
}
